import { action, computed, flow, makeObservable, observable } from 'mobx';
import api from '../utils/apiService';
import { apiFetcher } from '../utils/fetch';
import { makePersistable } from 'mobx-persist-store';

export default class Organization {
  constructor() {
    this.selected = undefined;
    this.items = [];
    this.serverDown = false;

    makeObservable(this, {
      selected: observable,
      items: observable,
      serverDown: observable,
      setSelected: action,
      setItems: action,
      // canSendEmails: computed,
      // canUploadDocumentsInCloud: computed,
      fetch: flow,
      fetchAndSelect: flow,
      create: flow,
      update: flow,
      validation: flow,
      validationXendit: flow,
      validationFaspay: flow,
      reset: flow,
      clear: flow,
      doneFirstConnection: flow,
    });

    makePersistable(this, {
      name: 'Organization', properties: ['selected', 'items'],
      storage: typeof window !== "undefined" ? window.localStorage : undefined,
      // expireIn: 604800000, // 7 day in milliseconds to match refresh token expiry time
      // removeOnExpiration: true,
    });

  }

  setSelected = (org, user) => {
    this.selected = org;
    if (!!user) {
      user.setRole(
        this.selected.members.find(({ email }) => email === user.email).role
      );
    }
  };

  setItems = (organizations = []) => {
    this.items = organizations;
  };


  // get canSendEmails() {
  //   return (
  //     !!this.selected?.thirdParties?.gmail?.selected ||
  //     this.selected?.thirdParties?.mailgun?.selected
  //   );
  // }

  *fetch() {
    try {
      this.serverDown = false;

      const response = yield apiFetcher().get('/realms');
      this.setItems(response.data);
      return 200;
    } catch (error) {
      console.error(error);

      const status = error?.response?.status;

      if (!status || status >= 500) {
        this.serverDown = true;
      }

      return status;
    }
  }

  *fetchAndSelect() {
    try {
      this.serverDown = false;

      const response = yield apiFetcher().get('/realms');
      this.setItems(response.data);

      if (this.selected?._id) {
        this.setSelected(
          this.items.find((item) => item._id === this.selected._id) || {}
        );
      }
    } catch (error) {
      console.error(error);

      const status = error?.response?.status;
      if (!status || status >= 500) {
        this.serverDown = true;
      }

      return status;
    }
  }

  *create(organization) {
    try {
      const response = yield apiFetcher().post('/realms', organization);
      return { status: 200, data: response.data };
    } catch (error) {
      console.error(error);
      return { status: error?.response?.status };
    }
  }

  *update(organization) {
    try {
      const response = yield apiFetcher().patch(
        `/realms/${organization._id}`,
        organization
      );
      return { status: 200, data: response.data };
    } catch (error) {
      console.error(error);
      return { status: error?.response?.status };
    }
  }
  *validation(organization) {
    try {
      const response = yield apiFetcher().post('/realms/midtrans', organization);
      return { status: 200, data: response.data };
    } catch (error) {
      console.error(error);
      return { status: error?.response?.status };
    }
  }

  *validationXendit(organization) {
    try {
      const response = yield apiFetcher().post('/realms/xendit', organization);
      return { status: 200, data: response.data };
    } catch (error) {
      console.error(error);
      return { status: error?.response?.status };
    }
  }

  *validationFaspay(organization) {
    try {
      const response = yield apiFetcher().post('/realms/faspay', organization);
      return { status: 200, data: response.data };
    } catch (error) {
      console.error(error);
      return { status: error?.response?.status };
    }
  }
  *reset(id) {
    try {
      const response = yield apiFetcher().delete(`/realms/reset/${id}`);
      const successMessage = response?.data || 'Data berhasil direset';
      return { status: 200, message: successMessage };
    } catch (error) {
      return { status: error?.response?.status };
    }
  }
  *clear() {
    // console.log("this.items", this.items)
    // console.log("this.selected", this.selected)
    this.selected = undefined
    window?.localStorage.clear();
    // console.log("After remove")
    // console.log("this.items", this.items)
    // console.log("this.selected", this.selected)
  }
  *doneFirstConnection() {
    this.selected.isFirstConnection = false
  }
}
